import { Alert, Typography } from '@mui/material';
import useTheme from '@mui/material/styles/useTheme';
import { Theme } from '@mui/system';
import { useContext } from 'react';
import { Link } from 'react-router-dom';
import BackNavigationButton from '../../components/common/BackNavigationButton';
import PageContainer from '../../components/common/PageContainter';
import ServiceActionsBlocks from '../../components/common/ServiceActions';
import useSubscriber from '../../hooks/useSubscriber';
import { SettingsContext } from '../../store/SettingsContext';

const InventoryOverview = () => {
    const settings = useContext(SettingsContext);
    const theme: Theme = useTheme();
    const { data: subscriber } = useSubscriber();

    return (
        <PageContainer>
            {subscriber && '_id' in subscriber && subscriber._id && (
                <>
                    <Typography variant="h5" sx={{ marginBottom: theme.spacing(2) }}>
                        <BackNavigationButton {...(subscriber && { url: `/subscribers/${subscriber._id}` })} /> Content Overview for{' '}
                        {subscriber.username}
                    </Typography>
                    <Alert severity="info" sx={{ marginBottom: theme.spacing(2) }}>
                        Please make sure you read the{' '}
                        <Link
                            to={`/subscribers/${subscriber._id}/services/inventory/welcome`}
                            style={{ color: theme.palette.primary.main, textDecoration: 'none' }}
                        >
                            <strong>Welcome</strong>
                        </Link>{' '}
                        information first!
                    </Alert>
                    <Typography>Manage the Vault, bundle content and sexting scripts in easy to use templates, and more.</Typography>
                    <ServiceActionsBlocks actions={settings.services.inventory.actions} subscriber={subscriber} theme={theme} />
                </>
            )}
        </PageContainer>
    );
};

export default InventoryOverview;
